import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import trpcApi from 'lib/trpcClient';
import { useNotification } from 'hooks/ui/useNotification';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/investment';

async function uploadInvestments(data) {
  return api.post(`investor/upload-investor-investment`, data);
}

interface ValidateInvestmentsData {
  gridData: any;
  gridDropdownsData: any;
  firmId: string;
}

async function validateInvestments(data: ValidateInvestmentsData) {
  const { data: response } =
    await api.post<Api.UploadInvestorInvestmentValidateResponse>(
      `investor/upload-investor-investment/validate`,
      data,
    );

  return response;
}

function useInvestmentUploadSaveAPI() {
  const queryClient = useQueryClient();
  const apiUtils = trpcApi.useUtils();

  return useMutation({
    mutationFn: uploadInvestments,
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: ['investments'],
      });
      apiUtils.investor.listInvestors.invalidate();
    },
  });
}

function useInvestmentUploadValidateAPI() {
  const notification = useNotification();
  const mutation = useMutation<
    Api.UploadInvestorInvestmentValidateResponse,
    AxiosError<ApiResponse<unknown>>,
    ValidateInvestmentsData
  >({
    mutationFn: validateInvestments,
  });

  useEffect(() => {
    if (mutation?.error?.response?.data?.responseMsg) {
      notification.error(
        'There was an error while uploading the preview. Please try again.',
      );
    }
  }, [mutation.error]);

  return mutation;
}

export function useInvestmentUpload() {
  return {
    save: useInvestmentUploadSaveAPI(),
    validate: useInvestmentUploadValidateAPI(),
  };
}
